<template>
    <div class="tw:flex tw:flex-col tw:sm:gap-4 tw:w-full">
        <div class="tw:flex tw:items-center tw:justify-between tw:gap-4">
            <div>
                <h4 class="tw:text-md tw:md:text-2xl tw:font-semibold tw:text-gray-800 tw:tracking-wide tw:max-sm:mb-0">
                    {{ title }}
                </h4>
                <p
                    v-if="extraText"
                    class="tw:hidden tw:md:block tw:text-sm tw:text-gray-500 tw:mt-1 tw:mb-0"
                >
                    {{ extraText }}
                </p>
            </div>
            <div class="tw:hidden tw:md:block">
                <slot name="select">
                </slot>
            </div>
            <div class="tw:flex tw:flex-col tw:items-center tw:gap-2">
                <slot name="actions">
                    <Button
                        v-if="atras"
                        customClass="tw:flex tw:flex-row"
                        icon="fas fa-arrow-left"
                        @click="volver"
                    >
                        Atrás
                    </Button>
                </slot>
            </div>
        </div>
        <div
            data-cy="page-title-select-mobile"
            :class="haySelectEnSlot() ? 'tw:block tw:md:hidden' : 'tw:hidden'"
        >
            <slot name="select">
            </slot>
        </div>
    </div>
</template>

<script setup>
    import { getCurrentInstance } from 'vue'
    import { useRouter } from '@/composables/common/router/useRouter'
    import Button from '@/modules/admin/ui/Button.vue'

    defineProps({
        title: {
            type: String,
            required: true
        },
        extraText: {
            type: String,
            default: null
        },
        atras: {
            type: Boolean,
            default: true
        }
    })

    const router = useRouter()
    const vm = getCurrentInstance().proxy

    /**
     * ¿El slot `select` renderiza algo?
     *
     * El wrapper responsive de móvil se pinta siempre (los E2E cuentan dos
     * instancias de `[data-cy="page-title-select"]`, una por slot, para poder
     * distinguir "no hay selector" de "no se renderizó"). Pero cuando el slot
     * viene vacío —MainContent lo pasa siempre, con el selector dentro
     * condicionado por `hideSelect`— ese wrapper queda como ítem del flex de
     * altura 0 y el `gap-4` del contenedor le sumaba 16px de aire debajo del
     * título: el doble de hueco abajo que arriba. Con `display:none` deja de
     * contar para el gap sin salir del DOM, así que el conteo de los E2E no
     * cambia.
     *
     * Se mira el vnode y no la existencia del slot, que siempre es verdadera:
     * un div con sólo comentarios adentro no es contenido.
     */
    function haySelectEnSlot() {
        const tieneContenido = vnode => {
            if (!vnode) return false
            if (typeof vnode.text === 'string') return vnode.text.trim() !== ''
            if (!vnode.tag) return false

            return Array.isArray(vnode.children) ? vnode.children.some(tieneContenido) : true
        }

        const slot = vm.$slots.select || vm.$scopedSlots.select
        const nodes = typeof slot === 'function' ? slot() : slot

        return Array.isArray(nodes) && nodes.some(tieneContenido)
    }

    function volver() {
        router.go(-1)
    }
</script>